<template>
  <div class="main">
    <Head type="index"/>

    <div class="banner swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img :src="$config.IMG_URL+'/banner/1.jpg'" />
        </div>
        <div class="swiper-slide">
          <img :src="$config.IMG_URL+'/banner/1.jpg'" />
        </div>
        <div class="swiper-slide">
          <img :src="$config.IMG_URL+'/banner/1.jpg'" />
        </div>
      </div>
    </div>

    <ul class="three row justify-between items-center">
      <li>
        <img class="icon" :src="$config.IMG_URL+'/icon/1.png'" />
        <div class="content">
          <p class="title">安心服务</p>
          <p class="txt">爱护生命，提高健康价值，让国人延年益寿生活更健康则是中智安心体验肩负的使命。</p>
        </div>
      </li>
      <li>
        <img class="icon" :src="$config.IMG_URL+'/icon/2.png'" />
        <div class="content">
          <p class="title">安心理赔</p>
          <p class="txt">您可通过中智安心理赔官网和微信，随时了解理赔进度。</p>
          <a target="_blank" href="https://tpa.51joying.com/html/">我要查询理赔 >></a>
        </div>
      </li>
      <li>
        <img class="icon" :src="$config.IMG_URL+'/icon/3.png'" />
        <div class="content">
          <p class="title">安心保险</p>
          <p class="txt">您可以通过中智安心保险获得贴心、合算、专业的保险保障服务。</p>
          <!-- a target="_blank" href="https://bx.51joying.com">我要去买保险 >></a -->
        </div>
      </li>
    </ul>

    <div class="why">
      <div class="title">为什么选择中智安心服务？<br/><span>WHY CHOOSE US</span></div>
      <div class="content">
        <img class="bg" :src="$config.IMG_URL+'/bg_1.jpg'" />
        <div class="txt">
          <p class="txt1">我们深知一份保险对一个家庭的重要性，我们秉承中立无倾 向的立场向您推荐适合您的险种或者给您中肯的建议。 用我们专业的服务换取您的满意体验！</p>
          <p class="txt2">我们优选各家公司优质产品，选择面更广，且产品容易进行 比较。</p>
          <p class="txt3">我们的专家理赔团队不仅提供理赔的跟进，更为您提供全面 的理赔分析。我们始终站在用户的角度，维护您的权益。</p>
        </div>
      </div>
    </div>

    <div class="problem">
      <img class="bg" :src="$config.IMG_URL+'/map.jpg'" />
      <div class="content row justify-between items-start">
        <div class="title">常见问题<br/><span>COMMON PROBLEM</span></div>
        <ul class="right">
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">1</p>
            <div class="txt">
              <b>重大疾病离我们有多远？</b>
              <p>据国家卫生部数据表明：人的一生罹患重大疾病的机会随着环境污染、食品安全、工作压力等多方面因素的影响，重大疾病的发生率也呈走高的态势。威胁中国人的癌症较严重的有8种，它们是：肺癌，肝癌，胃癌，食道癌，结肠癌，乳腺癌，急性白血病，神经细胞瘤。</p>
            </div>
          </li>
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">2</p>
            <div class="txt">
              <b>请问这些重疾产品的重疾都含有哪些啊？条款上看不明白呢。</b>
              <p>条款确实描述比较严谨，非专业医生很难看得明白的。一般重大疾病有以下特征：1.长期不能参加工作及日常生活；2.需要长期住 院治疗；3.需要大额医疗费；4.需要长期被他人照顾；5.需要长期进行康复，严重的康复期一般都要五年。重大疾病其实常见的 有这几种：癌症，心梗，心脏搭桥，重要器官移植等，其中各种癌症占所有重大疾病发病的80%，这样说您可能就清楚本质了。</p>
            </div>
          </li>
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">3</p>
            <div class="txt">
              <b>买保险容易理赔难，还必须是患有合同规定中的大病，而且每家保险公司疾病种类都各有不同，怎么鉴别呢？</b>
              <p>06年前重大疾病,各家公司都是按照自己的经验来定疾病种类及赔付的标准. 06年以后保监会和中国医师协会已经将此统一至25种, 所以您可以不用这么纠结了。这个病种和条款是保监会和各学科的院士们定的，全国都是统一的，各家在25种的基础上，另外增 加了一些不常见的病种而已。</p>
            </div>
          </li>
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">4</p>
            <div class="txt">
              <b>发生理赔是找你们还是找保险公司呀？</b>
              <p>发生理赔了，您可以拨打保险公司电话进行报案并处理理赔，也可以联系您的经纪人，我们的理赔专员也会帮助您进行理赔事宜，您可以通过专业获得的是中智保险经纪专业的理赔协助服务哦，通过中智购买，可以获得中智和保险公司双重服务的。</p>
            </div>
          </li>
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">5</p>
            <div class="txt">
              <b>重大疾病真的很常见吗？</b>
              <p>十大致癌因素 ：1.吸烟2.过量饮酒3.职业暴露4.环境污染5.食物污染6.药物7.慢性感染8.饮食与营养9.免疫抑制10.生殖因素与激素。</p>
            </div>
          </li>
          <li class="row justify-between items-start" style="margin-bottom:25px;">
            <p class="num">6</p>
            <div class="txt">
              <b>社保报销重疾医疗费用，报销85%的比例，个人付15%，即使患病了，个人付15%而已，有必要买商业保险吗？</b>
              <p>1社保属于健康保险范畴中的医疗保险,赔付的条件是发生医疗行为；重疾险是健康保险范畴中的疾病险,赔付的条件是重大疾病确 诊时，一次性给付，自由支配，可用于治疗或康复，或家庭生活费。2.社保的85%,是指在社保规定的目录内的药物等治疗,事实上, 大部分的药品一旦降价纳入社保,该药产量急剧减少。</p>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="about">
      <img class="bg" :src="$config.IMG_URL+'/bg_about.jpg'" />
      <div class="content">
        <div class="title">关于中智保险经纪<br/><span>ABOUT 51JOYING</span></div>
        <div class="txt">
          <p>中智保险经纪(上海)有限公司的主要股东是中国国际技术智力合作公司（上海分公司）。中智是唯一一家经国务院批准，可以在全国各省市直接设立机构进行作业的全国性人力资源专业服务公司。中智保险经纪也是中智旗下唯一的一家保险经纪公司</p>
          <p>中智保险经纪有限公司 总部设立于上海，并已在北京、江苏等一线省市开设了分支机构。同时逐步建立以国内主要中心城市为依托、向境外辐射的主导市场。我们以专业和诚信为广大客户提供合适的保险方案与优质的服务。致力于将公司发展成为具备全球经营能力的综合性保险经纪公司。</p>
          <p>中智保险经纪(上海)有限公司原身为成立于2005年6月的上海中盈保险代理有限公司，于2010年在中国保监会批准下正式翻牌成为保险经纪公司。我们经过几年的努力，公司取得了长足的进步，积累了众多优质客户。我们的客户遍及房地产及金融业、汽车及零部件制造业、工程建设、物流及运输业、人力资源服务等各个行业。</p>
          <p>我们坚守“诚信第一，客户至上”的理念，为客户提供一流水准的服务，并通过合作求得共赢。</p>
        </div>
        <!-- <div class="title" style="margin-top:500px;">关于安尊<br/><span>ZENITH (SHANGHAI) HEALTHCARE</span></div>
          <div class="txt" style="margin-top:500px;">
            <p>安尊（上海）健康管理有限公司系中智保险经纪(上海)有限公司之全资子公司，由技术全面、经验丰富、诚信敬业的团队组成，为客户提供：</p>
            <p>① 互联网+体检</p>
            <p>② 健康管理服务</p>
            <p>③ 医疗+保险相关服务。</p>
          </div> -->
      </div>
    </div>

    <div class="bx_online">
      <img :src="$config.IMG_URL+'/bx.png'" />
      <a class="link" target="_blank" href="http://bx.51joying.com"></a>
    </div>

    <div class="partner">
      <img class="bg" :src="$config.IMG_URL+'/bg_partner.jpg'" />
      <div class="content">
        <div class="title">合作伙伴<br/><span>PARTNER</span></div>

        <div class="pt_swiper swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <img class="img" :src="$config.IMG_URL+'/partner/1.jpg'" />
              <!--<ul class="row justify-start wrap">-->
                <!--<template v-for="i in 12">-->
                  <!--<li><img :src="$config.IMG_URL+'/partner/1.png'" /></li>-->
                <!--</template>-->
              <!--</ul>-->
            </div>
            <div class="swiper-slide">
              <img class="img" :src="$config.IMG_URL+'/partner/2.jpg'" />
              <!--<ul class="row justify-start wrap">-->
                <!--<template v-for="i in 10">-->
                  <!--<li><img :src="$config.IMG_URL+'/partner/1.png'" /></li>-->
                <!--</template>-->
              <!--</ul>-->
            </div>
          </div>
        </div>



        <div class="pt_page">
          <img class="page_img" :src="$config.IMG_URL+'/pt_page.png'" />
          <div class="pt_prev">
            <img :src="$config.IMG_URL+'/arr_left.png'" />
          </div>
          <div class="pt_next">
            <img :src="$config.IMG_URL+'/arr_right.png'" />
          </div>
        </div>
      </div>
    </div>

    <div class="follow">
      <img class="bg" :src="$config.IMG_URL+'/bg_follow.jpg'" />
      <div class="content">
        <div class="title">关注中智保险经纪<br/><span>FOLLOW US</span></div>
        <img class="mobile" :src="$config.IMG_URL+'/mobile2.png'" />
        <div class="qr row justify-between items-center">
          <img :src="$config.IMG_URL+'/qrcode.png'" />
          <div class="right">
            <p>FOLLOW ME</p>
            <p class="tit">关注中智 关注健康</p>
            <p class="small">中智 | 让健康生活不将就</p>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<script>
  import Head from './../components/head'
  import Footer from './../components/footer'
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.css';

  export default {
    name: 'Index',
    components: {
      Head,
      Footer
    },
    data () {
      return {

      }
    },
    mounted() {
      new Swiper ('.banner', {
        // pagination: {
        //   el: '.banner_page',
        // },
      })
      new Swiper ('.pt_swiper', {
        navigation: {
          nextEl: '.pt_next',
          prevEl: '.pt_prev',
        },
        autoplay: { delay: 3000, stopOnLastSlide: false, disableOnInteraction: false, },
        effect : 'fade',
        loop : true,
      })
    },
  }
</script>

<style scoped lang="less">
  @import "./../assets/common";
  .main{
    position: relative;
    width: 100%;
    min-width: 1364px;
    /*min-width: 800px;*/
    padding-top: 132px;
    max-width: 1920px;
    /*max-width: 1000px;*/
    margin: 0 auto;
    overflow: hidden;
  }


  .banner{
    width: 100%;
    height: 816px;
    .swiper-slide{
      position: relative;
      overflow: hidden;
      img{
        height: 816px;
        position: relative;
        left: 50%;
        transform: translate(-50%, 0);
      }
    }
  }

  .three{
    position: relative;
    width: 1364px;
    z-index: 10;
    margin: -70px auto 0 auto;
    li{
      width: 430px;
      height: 260px;
      position: relative;
      a, a:hover, a:focus, a:visited{
        color: #ffffff;
      }
      &:nth-child(1){
        background: #43B9F6;
      }
      &:nth-child(2){
        background: #6686FF;
      }
      &:nth-child(3){
        background: #9878FF;
      }
      .icon{
        position: absolute;
        left: 40px;
        top: 40px;
        width: 86px;
        height: 86px;
      }
      .content{
        position: relative;
        z-index: 10;
        width: 100%;
        padding: 54px 60px 0 60px;
        color: #ffffff;
        .title{
          font-size: 26px;
          height: 37px;
          line-height: 37px;
          font-weight: bold;
        }
        .txt{
          width: 100%;
          font-size: 14px;
          margin: 30px 0;
          line-height: 22px;
          height: 44px;
        }
        a{
          font-size: 14px;
          line-height: 25px;
          border-bottom: 1px solid #ffffff;
          .hover_a;
        }
      }
    }
  }


  .why{
    width: 100%;
    margin-top: 130px;
    .title{
      width: 1364px;
      margin: 0 auto 100px auto;
      line-height: 36px;
      font-size: 36px;
      color: #3399FF;
      span{
        font-size: 30px;
        color: #9BA1AF;
      }
    }
    .content{
      width: 100%;
      min-width: 1364px;
      position: relative;
      height: 752px;
      overflow: hidden;
      .bg{
        position: absolute;
        top: 0;
        height: 752px;
        left: 50%;
        transform: translate(-50%, 0);
      }
      .txt{
        position: relative;
        margin: 0 auto;
        width: 1364px;
        z-index: 10;
        color: #ffffff;
        height: 752px;
        font-size: 20px;
        line-height: 30px;
        .txt1{
          position: absolute;
          left: 0;
          top: 145px;
          width: 536px;
        }
        .txt2{
          position: absolute;
          right: 0;
          top: 145px;
          width: 536px;
        }
        .txt3{
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          top: 521px;
          width: 536px;
        }
      }
    }
  }

  .problem{
    width: 100%;
    height: 1024px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    .bg{
      position: absolute;
      top: 0;
      height: 1024px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .content{
      position: relative;
      width: 1364px;
      margin: 0 auto;
      z-index: 10;
      padding-top: 130px;
      .title{
        width: 320px;
        font-size: 36px;
        line-height: 36px;
        color: #3399FF;
        span{
          font-size: 30px;
          color: #9BA1AF;
        }
      }
      .right{
        width: 950px;
        position: relative;
        li{
          margin-bottom: 40px;
        }
        .num{
          width: 94px;
          height: 94px;
          background: #3399FF;
          box-shadow: 0 0 10px #6cadff;
          font-size: 74px;
          text-align: center;
          line-height: 94px;
          color: #ffffff;
        }
        .txt{
          width: 812px;
          line-height: 20px;
          b{
            font-size: 16px;
            padding-bottom: 13px;
            display: block;
          }
          p{
            font-size: 14px;
          }
        }
      }
    }
  }

  .about{
    width: 100%;
    height: 1200px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    .bg{
      position: absolute;
      top: 0;
      height: 1200px;
      left: 50%;
      transform: translate(-50%, 0);
      backgroud: repeat-y;
    }
    .content {
      position: relative;
      width: 1364px;
      margin: 0 auto;
      z-index: 10;
      height: 1200px;
      .title {
        position: absolute;
        left: 0;
        top: 130px;
        font-size: 36px;
        line-height: 36px;
        color: #ffffff;
        span {
          font-size: 30px;
          color: #1D4491;
        }
      }
      .txt{
        position: absolute;
        top:307px;
        right: 0;
        width: 1080px;
        font-size: 16px;
        line-height: 25px;
        color: #ffffff;
        p{
          margin-bottom: 30px;
        }
      }
    }
  }

  .bx_online {
    width: 100%;
    height: 530px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    margin: 100px 0;
    img {
      position: absolute;
      top: 0;
      height: 530px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .link{
      width: 190px;
      height: 50px;
      background: #ffffff;
      opacity: 0;
      left: 50%;
      position: absolute;
      z-index: 10;
      top: 312px;
      margin-left: 180px;
      .hover;
    }
  }

  .partner {
    width: 100%;
    height: 897px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    .bg {
      position: absolute;
      top: 0;
      height: 696px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .content {
      position: relative;
      width: 1364px;
      margin: 0 auto;
      z-index: 10;
      padding-top: 135px;
      .title{
        font-size: 36px;
        line-height: 36px;
        color: #ffffff;
        span{
          font-size: 30px;
          color: #1D4491;
        }
      }

      .pt_swiper{
        width: 1364px;
        margin: 120px auto 0 auto;
        .swiper-slide{
          position: relative;
          overflow: hidden;
          background: #ffffff;
          height: 266px;
          .img{
            width: 100%;
          }
          ul{
            width: 1364px;
            background: #ffffff;
            height: 266px;
            li{
              width: 214px;
              height: 100px;
              background: #FBFCFF;
              border-radius: 8px;
              position: relative;
              text-align: center;
              line-height: 100px;
              margin-bottom: 33px;
              margin-right: 13px;
              img{
                max-width: 170px;
                max-height: 50px;
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
              }
            }
          }
        }
      }

      .pt_page{
        width: 120px;
        height: 70px;
        margin: 160px auto 0 auto;
        position: relative;
        .page_img{
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
        >div img{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
        .pt_prev{
          background: #35F364;
          width: 39px;
          height: 39px;
          border-radius: 100%;
          box-shadow: 0 0 7px #83f396;
          position: absolute;
          left: 7px;
          top: 15.5px;
          img{
            width: 13px;
          }
          .hover_a;
        }
        .pt_next{
          background: #3399FF;
          width: 56px;
          height: 56px;
          border-radius: 100%;
          box-shadow: 0 0 7px #88bbff;
          position: absolute;
          right: 7.2px;
          top: 6.5px;
          img{
            width: 20px;
          }
          .hover_a;
        }
      }
    }
  }

  .follow {
    width: 100%;
    height: 800px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    .bg {
      position: absolute;
      top: 0;
      height: 800px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .content {
      position: relative;
      width: 1364px;
      margin: 0 auto;
      z-index: 10;
      height: 800px;
      .title{
        font-size: 36px;
        line-height: 36px;
        color: #ffffff;
        position: absolute;
        left: 0;
        top: 130px;
        span{
          font-size: 30px;
          color: #1D4491;
        }
      }
      .mobile{
        width: 398px;
        position: absolute;
        bottom: 0;
        left: 275px;
      }
      .qr{
        position: absolute;
        right: 0;
        top: 400px;
        height: 120px;
        width: 454px;
        img{
          width: 120px;
          height: 120px;
        }
        p{
          font-size: 20px;
          line-height: 30px;
          &.tit{
            font-size: 36px;
            font-weight: bold;
            line-height: 60px;
          }
          &.small{
            font-size: 18px;
          }
        }
      }
    }
  }

  .bottom {
    width: 100%;
    height: 487px;
    min-width: 1364px;
    position: relative;
    overflow: hidden;
    .bg {
      position: absolute;
      bottom: 0;
      height: 804px;
      left: 50%;
      transform: translate(-50%, 0);
    }
    .content {
      position: relative;
      width: 1364px;
      margin: 0 auto;
      z-index: 10;
      padding-top: 125px;

      .top{
        height: 140px;
        border-bottom: 1px solid #E6E6E6;
      }

      ul{
        width: 915px;
        position: relative;
        li{
          width: 305px;
          position: relative;
          .title{
            white-space: nowrap;
            font-size: 16px;
            line-height: 20px;
            padding-bottom: 20px;
          }
          .txt{
            width: 100%;
            a{
              display: inline-block;
              width: 100%;
              font-size: 16px;
              color: #909090;
              line-height: 20px;
              margin-bottom: 10px;
              &:hover{
                color: @blue;
                cursor: pointer;
              }
            }
          }
        }
      }
      .right{
        text-align: right;
        .title{
          font-size: 30px;
          line-height: 30px;
        }
        .txt{
          font-size: 14px;
          color: #909090;
          line-height: 20px;
          margin-top: 5px;
        }
      }
      .bottom{
        width: 100%;
        text-align: center;
        margin-top: 50px;
        .name{
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 5px;
        }
        .link{
          font-size: 14px;
          line-height: 20px;
          color: #909090;
        }
      }
    }
  }

  .content{
    overflow: hidden;
  }
</style>

<style lang="less">
  @import "./../assets/common";

  .banner_page{
    bottom: 20px !important;
    .swiper-pagination-bullet{
      background: #ffffff;
      opacity: 1;
      margin: 0 8px !important;
    }
    .swiper-pagination-bullet-active{
      background: @blue;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue